import moment from "moment";
import { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";


const SearchComponent = ({ onFilterChange }) => {
    const [date, setDate] = useState(null);
    const [location, setLocation] = useState("");
    const [tenderTypes, setTenderTypes] = useState('');
    const [companyName, setCompanyName] = useState(""); 
    const datepickerRef = useRef(null);


    useEffect(() => {
        onFilterChange({
            submission_date: moment(date).format("YYYY-MM-DD") ,
            upazila_name: location, 
            tender_section: tenderTypes, 
            key: companyName, 
        });
    }, [date, location, tenderTypes, companyName]);



    return (
        <div className="max-w-lg mx-auto p-4 bg-white rounded-lg shadow-md border border-gray-200 text-xs">
            {/* Submission Date */}
            <label className="block text-sm font-medium text-gray-700">Submission date</label>
            <div className="relative mt-1 focus-within:ring-2 focus-within:ring-blue-500 border border-gray-300 rounded-md">
                <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)} 
                    dateFormat="yyyy/MM/dd"
                    placeholderText="yyyy/mm/dd"
                    className="w-full p-2 pl-2 pr-10 outline-none"
                    ref={datepickerRef}
                />
                <div
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                    onClick={() => datepickerRef.current.setFocus()}
                >
                    <FaRegCalendarAlt size={20} />
                </div>
            </div>

            {/* Location Input Field */}
            <label className="block mt-4 text-sm font-medium text-gray-700 my-1">Location</label>
            <div className="relative mt-1 focus-within:ring-2 focus-within:ring-blue-500 border border-gray-300 rounded-md">
                <input
                    type="text"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}  // update location directly
                    placeholder="Enter location"
                    className="w-full p-2 outline-none"
                />
            </div>

            {/* Tender Types (Radio) */}
            <label className="block mt-4 text-sm font-medium text-gray-700 my-1">Tender types</label>
            <div className="flex flex-col gap-2 mt-1">
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="tenderType"
                        className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-400"
                        checked={tenderTypes === 'international'}
                        onChange={() => setTenderTypes('international')}
                    />
                    <span className="text-gray-700">International</span>
                </label>

                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="tenderType"
                        className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-400"
                        checked={tenderTypes === 'govt'}  
                        onChange={() => setTenderTypes('govt')}  
                    />
                    <span className="text-gray-700">Government</span>
                </label>

                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="tenderType"
                        className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-400"
                        checked={tenderTypes === 'private'}
                        onChange={() => setTenderTypes('private')}
                    />
                    <span className="text-gray-700">Private</span>
                </label>
            </div>


            {/* Company Name Input */}
            <label className="block mt-4 text-sm font-medium text-gray-700 my-1">Company name</label>
            <div className="relative mt-1 focus-within:ring-2 focus-within:ring-blue-500 border border-gray-300 rounded-md">
                <input
                    type="text"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)} // update companyName directly
                    placeholder="Write company name"
                    className="w-full p-2 outline-none"
                />
            </div>
        </div>
    );
};

export default SearchComponent;
